import pick from 'lodash/pick';
import get from 'lodash/get';
import flatten from 'lodash/fp/flatten';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import uniq from 'lodash/fp/uniq';

import I18n from '~/utils/i18n';
import { ITokenModel } from './model';

export default (self: ITokenModel) => {
  return {
    // the permission names as the Permissions column shows them (some keys carry a null)
    get apiPermissionFilterTags() {
      return self.permissions.filter(Boolean).map((permission) => I18n.t(`permissions.${permission}`));
    },
    get filterTags() {
      return self.apiPermissionFilterTags.map((tag) => tag.toLowerCase());
    },
    get searchString() {
      const searchFields = ['ownerName', 'permissions'];
      return flow(
        Object.values,
        flatten,
        map((field) => field.split('_')),
        flatten,
        uniq
      )(pick(self, searchFields))
        .join(' ')
        .toLowerCase();
    },
    get ownerName() {
      if (!self.owner) {
        return '';
      }
      return self.owner.name;
    },
    get deviceScope() {
      return get(self.query, 'node_id', '');
    }
  };
};
